import { render, staticRenderFns } from "./UserInfoPart2Form.vue?vue&type=template&id=06170f38"
import script from "./UserInfoPart2Form.vue?vue&type=script&lang=js"
export * from "./UserInfoPart2Form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports